import PropTypes from 'prop-types';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getEreaderProgressRatio } from 'a/hub/selectors/';
import { useFirstUserInteraction } from 'lib/hooks';
import { clearSessionProgress } from 'a/hub/actions/studentProgressActions';
import { BookIcon, BaseEarlyExitModal } from '../sharedComponents';

const EreaderEarlyExitModal = ({ closeModal, config }) => {
  const completeRatio = useSelector(getEreaderProgressRatio);

  const dispatch = useDispatch();

  const {
    heading = 'Progress Saved',
    text = 'Come back soon to complete all of the *Challenge Text* activities and earn a *reward*!',
  } = config;

  const firstUserInteraction = useFirstUserInteraction();
  const onClick = (e) => {
    dispatch(clearSessionProgress());
    firstUserInteraction(e);
    closeModal(e);
  };

  return (
    <BaseEarlyExitModal
      headerText={heading}
      descriptionText={text}
      onConfirm={onClick}
      actionScope="ereader-early-exit-modal"
    >
      <BookIcon top={200} left={345} completeRatio={completeRatio} />
    </BaseEarlyExitModal>
  );
};

EreaderEarlyExitModal.propTypes = {
  config: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default EreaderEarlyExitModal;
